
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Maintenance"
})
export default class Maintenance extends Vue {
  publicPath: string = process.env.BASE_URL as string;
  getImagePath(path: string) {
    return `${this.publicPath}${path}`;
  }
}
